import React from "react"
import TermsAndConditions from "@views/terms-and-conditions"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - Terms and Conditions"
      keywords={[
        `engineid`,
        `terms and conditions`,
      ]}
    />
    <TermsAndConditions />
  </div>
)

export default IndexPage
